<template>
  <div class="vuetify-select-file">
    <input
      ref="input"
      type="file"
      multiple
      :accept="accept"
      :disabled="disabled"
      @change="changed($event.target.files)">
<button @click="clicked">dddddd</button>


    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      fullscreen
      scrollable
      hide-overlay>
      <v-card>
        <v-toolbar
          dark
          color="primary">
          <v-btn
            icon
            dark
            @click="selected = null">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ label }}</v-toolbar-title>
        </v-toolbar>

        <template v-if="data !== null && type !== null">
          <embed
            v-if="type === 'application/pdf'"
            class="view-pdf"
            :type="type"
            :src="data"
            :key="data">

          <v-card-text v-else-if="type.substring(0, 6) === 'image/'"><img
            :src="data"
            :key="data">
          </v-card-text>

          <v-card-text v-else><v-alert
            type="error"
            :value="true">{{ type }} not supported.</v-alert>
          </v-card-text>
        </template>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>
// https://gist.githubusercontent.com/ecmel/3d3d918f403140ff563d274c773508bf/raw/00ee8a3db7751e1fc2e4676e3d666246a10bf554/select-file.vue
import VuetifySelect from './vuetify-select'

export default {
  name: 'VuetifySelectFile',
  components: {
    VuetifySelect
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default () {
        return []
      }
    },
    item: {
      type: 'select',
      label: '¿Quién eres?',
      columns: 'xs12 sm12 md12 lg12',
      value: '',
      itemText: 'name',
      itemValue: 'name',
      avatars: false,
      options: [
        {
          seller_id: '1',
          name: 'Diego',
          icon: 'account_box',
          label: true,
          chipColor: 'primary',
          iconColor: 'white',
          textColor: 'white'
        },
        {
          seller_id: '1',
          name: 'Ana',
          icon: 'account_box',
          label: true,
          chipColor: 'primary',
          iconColor: 'white',
          textColor: 'white'
        }
      ],
      default: {
        parent: 'sellerName',
        seller_id: '',
        seller_name: '',
        icon: 'account_box',
        label: true,
        chipColor: 'primary',
        iconColor: 'white',
        textColor: 'white'
      },
      rules: [],
      required: true,
      autocomplete: true,
      disabled: false,
      chips: true,
      addOnEnter: true,
      hideSelected: true,
      noDataText: 'Pulsa enter para agregar vendedor'
    },
    fetch: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      items: this.value ? this.value.slice() : [],
      dialog: false,
      data: null,
      type: null,
      selected_: null
    }
  },
  computed: {
    selected: {
      get () {
        return this.selected_
      },
      set (value) {
        if (this.data) {
          URL.revokeObjectURL(this.data)
        }

        if (value) {
          this.data = URL.createObjectURL(value.file || value.blob)
          this.type = value.type
          this.dialog = true
        } else {
          this.dialog = false
          this.type = null
          this.data = null
        }

        this.selected_ = value
      }
    }
  },
  beforeDestroy () {
    this.selected = null
  },
  methods: {
    clicked () {
      this.$refs.input.click()
    },
    changed (files) {
      if (files.length === 0) {
        return
      }

      const types = this.accept ? this.accept.split(',') : []

      let update = false

      for (let i = 0, file, push; i < files.length; i++) {
        file = files[i]

        push = this.accept === null

        for (let j = 0, type; j < types.length; j++) {
          type = types[j].trim()

          if (type === file.type ||
              (type.endsWith('*') &&
              file.type.startsWith(type.substring(0, type.length - 1)))) {
            push = true
            break
          }
        }

        for (let j = 0, item; j < this.item.value.length; j++) {
          item = this.item.value[j]

          if (item.name === file.name) {
            push = false
            break
          }
        }

        if (push) {
          this.item.value.push({
            name: file.name,
            type: file.type,
            size: file.size,
            file
          })
          update = true
        }
      }

      this.$refs.input.value = ''

      if (update) {
        this.update()
      }
    },
    remove (index) {
      this.item.value.splice(index, 1)
      this.update()
    },
    update () {
      this.$emit('change', this.item.value.slice())
    },
    preview (item) {
      if (item.file || item.blob) {
        this.selected = item
      } else if (this.fetch) {
        this.fetch(item).then(() => { this.selected = item })
      }
    }
  }
}
</script>

<style scoped>
  .view-pdf {
    width: 100%;
    height: 100%;
  }

  .vuetify-select-file input[type=file] {
    position: absolute;
    filter: alpha(opacity=0);
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-select-file.vue